// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6c537549701ce781","3713":"1b5122098e30ec49","8288":"c3fa6fc986653f3d","8686":"1b05aa83d3558204"}[chunkId] + ".css";
};